exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".N6cG5OwWabs5c1{border-radius:32px;font-size:12px;font-weight:400;line-height:16px;height:16px;padding:2px 8px;text-align:center;text-transform:uppercase}._3_BUw86sJ8u9HQ{background-color:#d6ecd2;color:#49852e}._3VnRI9FunkfM51{background-color:#bcd9ea;color:#094c72}._1AfbioR3Pep5T8{background-color:#eddbf4;color:#484553}._2XJRfB3zhZqd90{vertical-align:bottom}._2IZfG2ojHZnIy1{display:inline-block}", ""]);

// exports
exports.locals = {
	"lozenge": "N6cG5OwWabs5c1",
	"green": "_3_BUw86sJ8u9HQ",
	"blue": "_3VnRI9FunkfM51",
	"purple": "_1AfbioR3Pep5T8",
	"verticallyBottom": "_2XJRfB3zhZqd90",
	"inlineFlex": "_2IZfG2ojHZnIy1"
};